export interface InspectionOfflineCheckJobRequest {
  inspectionId: number
  fileName: string
}

export function InspectionOfflineCheckJobRequestToJSON(
  value: InspectionOfflineCheckJobRequest
): any {
  return {
    inspection_id: value.inspectionId,
    file_name: value.fileName
  }
}
